export const baseURL = 'https://server.spiraldevs.com:8000/';
// export const baseURL = 'http://localhost:8000/';




